import { isHistoryAvailable } from "./caniuse";

export const setFilterQueryParams = (queryName: string, values: string[]) => {
    if (isHistoryAvailable() && values.length > 0 && window) {
        const url = new URL(window.location.toString())
        url.searchParams.set(queryName, values.join(','))
        history.pushState({}, "", url)
    } else if (isHistoryAvailable()) {
        const url = new URL(window.location.toString());
        url.searchParams.delete(queryName)
        history.pushState({}, "", url)
    }
}

export const getFilterQueryParams = (queryName: string) => {
    if (isHistoryAvailable() && window) {
        const url = new URL(window.location.toString())
        var currentQuery = url.searchParams.get(queryName)
        if (currentQuery) {
            return currentQuery.split(',');
        }
        return [];
    }
}
